import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  height: 100%;
  padding-bottom: 30px;

  .scroll::-webkit-scrollbar {
    display: none;
  }
`;

export const Form = styled.div<{ isFirst: boolean }>`
  display: ${(props) => (props.isFirst ? "flex" : "grid")};
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  justify-content: ${(props) => (props.isFirst ? "center" : "")};

  @media (max-width: 728px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Btns = styled.div<{ disabled?: boolean }>`
  display: ${(props) => (props.disabled ? "none" : "flex")};
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin-top: 25px;
`;

export const Scroll = styled.div``;

export const List = styled.div`
  padding-bottom: 20px;
`;

export const Center = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BoxSelect = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 15px;
`;

export const BoxButtonsSelect = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;

  button {
    width: 100%;
  }
`;

export const BoxTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LegendTitle = styled.div`
  display: flex;
  font-size: 24px;
  font-weight: bold;
  color: #006f5e;
  margin-bottom: 15px;
`;

export const QuaLegend = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuaLegendItem = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 3px;
`;

export const QuaLegendImg = styled.div`
  display: flex;
  img {
    width: 20px;
    height: 20px;
  }
`;

export const QuaLegendTitle = styled.div`
  display: flex;
  font-size: 12px;
`;

export const SortBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 12px 0 16px 0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SortLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #5d5d5d;
  white-space: nowrap;
`;

export const SortButton = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid ${(props) => (props.active ? "#006f5e" : "#cfcfcd")};
  background-color: ${(props) => (props.active ? "#006f5e" : "#f5f5f5")};
  color: ${(props) => (props.active ? "#fff" : "#5d5d5d")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    border-color: #006f5e;
    background-color: ${(props) => (props.active ? "#005548" : "#e8f5e9")};
    color: ${(props) => (props.active ? "#fff" : "#006f5e")};
  }
`;

export const NetworkButton = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  border: none;
  background-color: ${(props) => (props.active ? "#53b2e9" : "#f5f5f5")};
  color: ${(props) => (props.active ? "#fff" : "#9e9e9e")};
  border: 1px solid ${(props) => (props.active ? "#53b2e9" : "#cfcfcd")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    opacity: ${(props) => (props.active ? 1 : 0.5)};
    filter: ${(props) =>
      props.active
        ? "none"
        : "grayscale(1) drop-shadow(0 0 1px rgba(0,0,0,0.35))"};
    transition: all 0.2s ease;
  }

  &:hover {
    border-color: #53b2e9;
    background-color: ${(props) => (props.active ? "#3aa0de" : "#e8f4fc")};
    color: ${(props) => (props.active ? "#fff" : "#53b2e9")};
  }
`;

export const NetworkSelect = styled.select`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #cfcfcd;
  background-color: #f5f5f5;
  color: #5d5d5d;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  outline: none;
  appearance: auto;
  transition: border-color 0.2s ease;

  &:focus,
  &:hover {
    border-color: #006f5e;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
